import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { ActivatedRoute, Router } from "@angular/router";
import { TicketService } from "../../ticket.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";
import { ICurrentUser } from "app/auth/models/user-interface";
import { ICategoryTicket, IFile, IFileComplete, ITicket, ITicketSingle } from "../../models/tickets";

@Component({
  selector: "app-all-users-ticket-list",
  templateUrl: "./all-users-ticket-list.component.html",
  styleUrls: ["./all-users-ticket-list.component.scss"],
})
export class AllUsersTicketListComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("viewTicket") viewTicket: ElementRef;
  @ViewChild("replyTicket") replyTicket: ElementRef;
  public ticket_list: ITicket[] = [];
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public currentTicket: ITicketSingle = null;
  public searchStatus: number = 10;
  public selectedCategory: string = "all";
  public categories: ICategoryTicket[] = [];
  public messageReplyTicket: string = "";
  public me: ICurrentUser;
  public idFromNotifications: string = "";
  public attachmentsListObj: IFile[] = [];
  public attachmentsList: IFile[] = [];

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _ticketService: TicketService,
    public activatedRoute: ActivatedRoute,
    public _router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idFromNotifications = params.id;
    });
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();
    if (!this._authenticationService.hasCapability("view_ticket_list")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.contentHeader = {
      headerTitle: "MENU.SUPPORT_REQUEST_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "TITLES.SUPPORT",
            isLink: false,
          },
          {
            name: "MENU.SUPPORT_REQUEST_LIST",
            isLink: false,
          },
        ],
      },
    };
    this.categories = await this._ticketService.getCategoriesList();
    this.categories = this.categories.filter((cat) => cat.role_ids.includes(this.me.role_id)); //Filtro le categorie che l'utente puo' vedere con quel ruolo
    await this.loadTicket().then(() => this._utilService.hideLoading());
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadTicket() {
    this.ticket_list = await this._ticketService.getList();
    this.ticket_list = this.ticket_list.sort((a, b) => (moment(b.insert_date) > moment(a.insert_date) ? 1 : -1));
    if (this.ticket_list && this.ticket_list.length > 0) {
      //Se ci sono ticket in pending il filtro di ricerca verrà impostato su quelli in pending
      const isThereTicketPending = this.ticket_list.filter((item) => item.last_step.status === 0);
      if (isThereTicketPending && isThereTicketPending.length > 0) {
        this.searchStatus = 0;
      }
    }

    this.ticket_list.map((item: ITicket) => {
      if (item.last_step.status === 1) {
        item.enabled_label = "TAKEN_CHARGE";
      } else if (item.last_step.status === 2) {
        item.enabled_label = "COMPLETED";
      } else {
        item.enabled_label = "PENDING";
      }
    });
    if (this.idFromNotifications) {
      this.modalOpen(this.viewTicket, { id: Number(this.idFromNotifications), title: null, category_name: null, category: null, insert_date: null, user: null, last_step: null });
    }
  }

  ticketList() {
    let items: ITicket[] = this.ticket_list;

    const keywords: string = this.searchKeyword.trim().toLowerCase();
    const category: string = this.selectedCategory.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: ITicket) => item.title.toLowerCase().includes(keywords) || item.user.complete_name.toLowerCase().includes(keywords));
    }
    if (this.searchStatus < 3) {
      items = items.filter((item: ITicket) => Number(item.last_step.status) === Number(this.searchStatus));
    }
    if (category.length > 0 && category !== "all") {
      items = items.filter((item: ITicket) => item?.category_name?.toLowerCase().includes(category));
    }
    return items;
  }

  public async modalOpen(modalBasic, ticket: ITicket) {
    await this._utilService.showLoading();
    this.closeModal();
    this.currentTicket = await this._ticketService.get(ticket.id);
    await this._utilService.hideLoading();
    this._modalService.open(modalBasic, {
      size: "lg",
      centered: true,
    });
    this.messageReplyTicket = "";
  }

  loadAttachment(file: string) {
    return this._utilService.getFile(file);
  }

  closeModal() {
    this._modalService.dismissAll();
    this.callbackFn.emit();
    this.attachmentsListObj = [];
    this.attachmentsList = [];
  }

  async takeCharge(currentTicket) {
    if (!this._authenticationService.hasCapability("ticket_manage_status")) {
      return false;
    }
    const data: { status: number; ticket_id: number } = {
      status: 1,
      ticket_id: currentTicket.id,
    };
    this._utilService.showLoading();
    await this._ticketService
      .updateStatus(data)
      .then(async () => {
        this._utilService.hideLoading();
        this.closeModal();
        this.idFromNotifications = "";
        await this._utilService.showSWALSuccess({ text: "SUCCESS_TAKE_CHARGE" });
        await this.loadTicket();
        this.searchStatus = 1;
      })
      .catch(async () => {
        this._utilService.hideLoading();
        this.closeModal();
        this.idFromNotifications = "";
        await this._utilService.showSWALError({ text: "ERROR_TAKE_CHARGE" });
      });
  }

  async addAttachmentToList(files: IFileComplete[]) {
    // I create a variable from the actual list
    let updatedList: IFile[] = this.attachmentsListObj.filter((item: IFile) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (typeof file.size === "number" && file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: IFile = updatedList.find((item: IFile) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.filter((item: IFile) => item.name !== file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachmentsList.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(Number(file.size)),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachmentsListObj = updatedList;
  }

  removeAttachmentFromList(index_attachment: number) {
    this.attachmentsListObj = this.attachmentsListObj.filter((item: IFile, i: number) => i !== index_attachment);
    this.attachmentsList = this.attachmentsList.filter((item: IFile, i: number) => i !== index_attachment);
  }

  async sendReplyTicket() {
    if (!this._authenticationService.hasCapability("ticket_manage_status")) {
      return false;
    }
    if (!this.messageReplyTicket || this.messageReplyTicket.length < 1) {
      await this._utilService.showSWALError({ text: "EMPTY_FIELD_FORM" });
      return false;
    }
    const data: { ticket_id: number; status: number; response: string } = {
      ticket_id: this.currentTicket.id,
      status: 2,
      response: this.messageReplyTicket,
    };
    this._utilService.showLoading();
    await this._ticketService
      .updateStatus(data)
      .then(async () => {
        if (this.attachmentsList && this.attachmentsList.length > 0) {
          this._utilService.hideLoading();
          await this.uploadAttachments(this.currentTicket.id);
        }
        this._utilService.hideLoading();
        this.closeModal();
        this.idFromNotifications = "";
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REPLY_SUPPORT_REQUEST" });
        await this.loadTicket();
        const thereAreTicketInPending: ITicket[] = this.ticket_list.filter((ticket) => ticket.last_step.status === 1);
        this.searchStatus = thereAreTicketInPending && thereAreTicketInPending.length > 0 ? 1 : 2;
      })
      .catch(async () => {
        this._utilService.hideLoading();
        this.closeModal();
        this.idFromNotifications = "";
        await this._utilService.showSWALError({ text: "ERROR_REPLY_SUPPORT_REQUEST" });
      });
  }

  async uploadAttachments(supportRequestId: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachmentsList.map((file: IFile) => {
        return this._ticketService.uploadFile(file, supportRequestId, true);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }
}
